// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import { GlobalStyles }  from './styles/GlobalStyles';
import ThemeModeProvider from './context/ThemeProvider';
import { AuthProvider }  from './context/AuthProvider';
import { ModalProvider } from './context/ModalProvider';
import { ApiProvider }   from './context/ApiProvider';
import { UIProvider }    from './context/UIProvider';
import { FunnelCartProvider } from './context/FunnelCartProvider';
import GAListener from './analytics/GAListener';
import ConsentBanner from './components/ConsentBanner';



/* Stripe */
import { Elements } from '@stripe/react-stripe-js';

/* Redux */
import { Provider as ReduxProvider } from 'react-redux';
import { store } from './store';

import { loadStripe } from '@stripe/stripe-js';

const stripePk = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ''; // ← align with your .env and stuff
const stripePromise = stripePk
  ? loadStripe(stripePk, {
      developerTools: {
        assistant: {
          enabled: false,
        },
      },
    })
  : null;

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <BrowserRouter>
        <AuthProvider>
          <ApiProvider>
            <QueryClientProvider client={queryClient}>
              <ThemeModeProvider>
                <UIProvider>
                  <ModalProvider>
                    <GlobalStyles />
                    <FunnelCartProvider>
                      <Elements stripe={stripePromise ?? null}>
                        <GAListener />
                        <ConsentBanner />
                        <App />
                      </Elements>
                    </FunnelCartProvider>
                  </ModalProvider>
                </UIProvider>
              </ThemeModeProvider>
            </QueryClientProvider>
          </ApiProvider>
        </AuthProvider>
      </BrowserRouter>
    </ReduxProvider>
  </React.StrictMode>
);
